import { Pagination, Table } from '@quero-delivery/quero-components-web';
import styles from './extract-list.module.scss';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';
import { ExtractRow } from '../extract-row';
import type { Extract } from '../../api/types';

interface ExtractListProps {
  extracts: Extract[];
  page?: number;
  totalCount: number;
  onPageChange?: (page: number) => void;
  hasPagination?: boolean;
  isFullTable?: boolean;
}

function ExtractList({
  extracts,
  page = 1,
  totalCount = 0,
  onPageChange,
  hasPagination = false,
  isFullTable = false,
}: ExtractListProps) {
  return (
    <div className={styles.containerTable}>
      <Table
        compact
        textAlign="left"
        pagination={
          hasPagination ? (
            <div className="pagination">
              <Pagination
                size="sm"
                limitPerPage={DEFAULT_LIMIT_REQUEST}
                currentPage={page}
                totalCount={totalCount}
                onPageChange={onPageChange}
              />
            </div>
          ) : undefined
        }
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Data</Table.HeaderCell>
            <Table.HeaderCell>Valor</Table.HeaderCell>
            {isFullTable ? <Table.HeaderCell>Saldo</Table.HeaderCell> : null}
            <Table.HeaderCell>Operação</Table.HeaderCell>
            <Table.HeaderCell>Motivos</Table.HeaderCell>
            {isFullTable ? (
              <Table.HeaderCell>Descrição</Table.HeaderCell>
            ) : null}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {extracts.map(extract => (
            <ExtractRow
              key={extract._id}
              extract={extract}
              isFullTable={isFullTable}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
}

export { ExtractList };
